
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-linecap":"round","stroke-width":"1.5","stroke":"#000","fill":"none","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M.75 17.25v-.01c0-3.73 3.02-6.76 6.75-6.75.9 0 1.8.18 2.64.54M7.5.75A4.125 4.125 0 107.5 9a4.125 4.125 0 100-8.25zM18.75 14.25H16.7c-.75 0-1.35.6-1.35 1.34 0 .54.33 1.03.84 1.24l2.06.82-.01-.01c.68.27 1.02 1.05.74 1.74-.21.51-.7.84-1.25.84H15.7M17.25 14.25v-.75M17.25 21v-.75"}}),_c('path',{attrs:{"d":"M17.25 11.25a6 6 0 100 12 6 6 0 100-12z"}})])])
          )
        }
      }
    